module.exports = __webpack_public_path__ + "c_static/img/2-3电脑天猫收藏夹.b4e46cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/2-3电脑天猫收藏夹.jpg
// module id = AO55
// module chunks = 33